import React from "react";
import { DashboardList } from "@veiligh/reporting-core/ui";
import { toast } from "sonner";
import TableForData from "~/components/shared/datatable/table";
import { TableMenuAction } from "~/components/shared/table-menu";

import {
  Button,
  Checkbox,
  ConfirmDeleteDialog,
  Dialog,
  DialogContent,
  DialogTitle,
  DropdownMenuItem,
  Icon,
} from "~/components/ui";

const ReportsNewDashboardPage: React.FC = () => {
  return (
    <DashboardList
      TableComponent={TableForData as any}
      tableTitle="Dashboard Management"
      ButtonComponent={Button}
      DialogComponent={Dialog}
      DialogContentComponent={DialogContent}
      DialogTitleComponent={DialogTitle}
      IconComponent={Icon}
      CheckboxComponent={Checkbox}
      ConfirmDeleteDialogComponent={ConfirmDeleteDialog}
      TableMenuActionComponent={TableMenuAction}
      DropdownMenuItemComponent={DropdownMenuItem}
      toast={toast}
    />
  );
};

export default ReportsNewDashboardPage;
